// extracted by mini-css-extract-plugin
export var lightbox = "CategoryGallery-module--lightbox--O13S5";
export var lightbox_child = "CategoryGallery-module--lightbox_child--K1UQO";
export var close = "CategoryGallery-module--close--jDj6V";
export var open_lightbox = "CategoryGallery-module--open_lightbox---iWpb";
export var lightbox_image = "CategoryGallery-module--lightbox_image--r7uMC";